import i18n from "i18next";
import React, { useEffect, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { DevModal } from "@components/Helpers";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

function MyTracker({ developerId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:developer:mytracker", { developer_id: developerId }));
    const { setToastMessage } = useAppContext();
    const [myTrackerInviteShow, setMyTrackerInviteShow] = useState(false);
    const [email, setEmail] = useState("");
    const developerCommonInfo = useRouteLoaderData("developerCommonInfo");
    const commonInfo = useRouteLoaderData("commonInfo");
    const isSuperUser = commonInfo?.account.is_super;
    const { api_post } = useRequest();

    const { developer } = developerCommonInfo;
    const myTrackerInviteClose = () => setMyTrackerInviteShow(false);

    const sendInviteHandle = (ev) => {
        api_post(ev, url_reverse("api:developer:mytracker", { developer_id: developer.id }), {
            params: { email },
            then: (resp) => {
                if (resp.status === "ok") {
                    myTrackerInviteClose();
                } else if (resp.message) {
                    setToastMessage(resp.message);
                }
            },
        });
    };

    const myTrackerButton =
        developer &&
        (apiData?.my_tracker_invite_used ? (
            <DevForm.Button
                size="lg"
                className="w-50"
                style={{ backgroundColor: "#409D44", borderColor: "#409D44", borderRadius: "2em" }}
                href="https://tracker.my.com/"
                name="mytracker_on"
                target="_blank"
            >
                <i className="fa fa-check"></i> {t("MyTracker подключен")}
            </DevForm.Button>
        ) : (
            <DevForm.Button
                size="lg"
                className="w-50"
                style={{ backgroundColor: "#FD4C2A", borderColor: "#FD4C2A", borderRadius: "2em" }}
                name="mytracker_off"
                onClick={() => setMyTrackerInviteShow(true)}
            >
                {t("Подключить MyTracker")}
            </DevForm.Button>
        ));

    const myTrackerInviteText = t(
        "MyTracker - система трекинга трафика. С помощью MyTracker вы можете отслеживать основные метрики проекта, " +
            "а также анализировать свои маркетинговые активности. Напомним, что Store применяет пониженную комиссию 5% " +
            "ко всей выручке от пользователей, приведенных в игру самим разработчиком. Учет ведется по данным MyTracker"
    );

    const docUrl =
        i18n.language === "ru_RU"
            ? "https://cloud.mail.ru/public/JwsG/3VKdnwYTm"
            : "https://cloud.mail.ru/public/2xTv/cTMAedG9p";

    useEffect(() => {
        if (developer?.my_tracker_email) {
            setEmail(developer?.my_tracker_email);
        }
    }, [developer]);

    if (!apiData) return null;

    return (
        <CommonCard header={header}>
            <div className="d-flex justify-content-center">
                <div className="w-75">
                    <h2>{t("Система аналитики и атрибуции трафика MyTracker")}</h2>

                    <h3 className="mt-5 mb-2">{t("Возможности")}</h3>

                    <ul className="mt-2">
                        <li className="mb-2">
                            {t(
                                "Анализируйте поведение своей аудитории с помощью широкого набора фильтров в " +
                                    "функционале отчетов. Сервис также позволяет отслеживать статистику базового и " +
                                    "дополнительного промо в VK Play"
                            )}
                            ;
                        </li>
                        <li>
                            {t(
                                "Оценивайте эффективность баннеров по разным каналам с помощью опции трекинговых " +
                                    "ссылок. Для более точных замеров можно создавать уникальные ссылки под каждое " +
                                    "размещение."
                            )}
                        </li>
                    </ul>

                    <div className="mt-5 d-flex justify-content-center">{myTrackerButton}</div>

                    {(email || developer?.my_tracker_email) && (
                        <div className="mt-3 d-flex justify-content-center">
                            <div>
                                {t("Email для доступа в MyTracker")}
                                {": "} <b>{email || developer?.my_tracker_email}</b>
                            </div>
                        </div>
                    )}

                    <h3 className="mt-5 mb-2">{t("Этапы подключения")}</h3>

                    <ol>
                        <li className="mb-2">
                            {t(
                                "Нажмите кнопку «Подключить MyTracker» и введите адрес электронной почты, на которую" +
                                    " будет регистрация в MyTracker. Она должна совпадать с почтой вашего VK ID." +
                                    " Нажмите «Отправить»."
                            )}
                        </li>
                        <li className="mb-2">
                            {t(
                                "В письме «MyTracker приглашение» вы найдете подробную инструкцию по подключению к системе."
                            )}
                        </li>
                        <li>
                            <Trans>
                                Перед принятием приглашения, зарегистрируйтесь или авторизуйтесь в MyTracker
                                <a href="https://tracker.my.com/" target="_blank">
                                    {" "}
                                    https://tracker.my.com/
                                </a>{" "}
                                с помощью VK ID.
                            </Trans>
                            <ul style={{ paddingLeft: "1.2em" }}>
                                <Trans>
                                    Больше о VK ID -{" "}
                                    <a href="https://id.vk.com/about/id" target="_blank">
                                        {" "}
                                        https://id.vk.com/about/id
                                    </a>
                                </Trans>
                            </ul>
                            <ul style={{ paddingLeft: "1.2em" }}>
                                <Trans>
                                    <b>ВАЖНО</b>: VK ID должен соответствовать почте на которую пришло приглашение в
                                    MyTracker.
                                </Trans>
                            </ul>
                        </li>
                        <li>
                            {t(
                                "После успешной авторизации в MyTracker вернитесь к письму с приглашением и нажмите" +
                                    "«Принять приглашение»."
                            )}
                            <ul style={{ paddingLeft: "1.2em" }}>
                                <Trans>
                                    <b>ВАЖНО</b>: приглашение действует 3 дня.
                                </Trans>
                            </ul>
                        </li>
                        <li>{t("Готово — вы получили доступ к системе!")}</li>
                    </ol>

                    <Trans>
                        В профиле MyTracker автоматически появятся проекты кабинета. Заводить дополнительно счетчики не
                        нужно.
                    </Trans>

                    <h3 className="mt-5 mb-3">
                        <Trans>
                            О том, как подключиться к системе MyTracker, создавать ссылки и строить отчёты, читайте в{" "}
                            <a href={docUrl} target="_blank">
                                документации
                            </a>
                            .
                        </Trans>
                    </h3>
                </div>
            </div>

            <DevModal
                size="lg"
                show={myTrackerInviteShow}
                onHide={myTrackerInviteClose}
                header={t("Подключить MyTracker")}
                body={
                    <>
                        <p>
                            {t("На указанный email придет письмо с инструкциями по заведению аккаунта в")}{" "}
                            <OverlayTrigger placement="bottom" overlay={<Tooltip>{myTrackerInviteText}</Tooltip>}>
                                <a href="https://tracker.my.com/docs/quickstart" target="_blank">
                                    MyTracker
                                </a>
                            </OverlayTrigger>
                        </p>
                        <FormFieldGroup label="E-mail">
                            <DevForm.TextInput
                                type="email"
                                name="my_tracker_invite_email"
                                value={developer?.my_tracker_email || email}
                                readOnly={Boolean(developer?.my_tracker_email) && !isSuperUser}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormFieldGroup>
                        <DevForm.Button variant="primary" name="send_invite" onClick={sendInviteHandle}>
                            {t("Отправить")}
                        </DevForm.Button>
                    </>
                }
                renderWrapper={(children) => <Form>{children}</Form>}
            />
        </CommonCard>
    );
}

export default MyTracker;
